export default __webpack_public_path__ + "static/media/profile.36660c69.jpeg";